import { gsap } from 'gsap';
import Observer from '../classes/Observer';

const MARQUEE_SPEED = 80;

let instances = [];

class Marquee extends Observer {
  constructor(el) {
    super({ isOnce: false });

    this.el = el;
    this.isVisible = false;
    this.isHovered = false;
    this.isCtaMarquee = el.classList.contains('marquee-cta');
    this.$track = $(el).find('.marquee__track, .marquee-cta__track');

    if (!this.$track.length) return;

    this.loopWidth = this.$track.get(0).scrollWidth / 2;

    this.animation = gsap.fromTo(
      this.$track.get(0),
      { x: 0 },
      {
        x: -this.loopWidth,
        duration: this.loopWidth / MARQUEE_SPEED,
        ease: 'none',
        repeat: -1,
        paused: true,
      },
    );

    if (this.isCtaMarquee) {
      $(this.el)
        .on('mouseenter.marquee', () => {
          this.isHovered = true;
          this.updatePlayback();
        })
        .on('mouseleave.marquee', () => {
          this.isHovered = false;
          this.updatePlayback();
        });
    }

    if (this.observer) {
      this.observer.observe(el);
    } else {
      this.animateIn();
    }
  }

  updatePlayback() {
    if (!this.animation) return;

    if (this.isVisible && !this.isHovered) {
      this.animation.play();
    } else {
      this.animation.pause();
    }
  }

  animateIn() {
    this.isVisible = true;
    this.updatePlayback();
  }

  animateOut() {
    this.isVisible = false;
    this.updatePlayback();
  }

  destroy() {
    $(this.el).off('.marquee');
    this.animation?.kill();

    if (this.observer) {
      this.observer.unobserve(this.el);
    }
  }
}

export function initMarquee() {
  instances.forEach((instance) => instance.destroy());
  instances = [];

  $('.js-marquee').each((_, el) => {
    instances.push(new Marquee(el));
  });
}

export function destroyMarquee() {
  instances.forEach((instance) => instance.destroy());
  instances = [];
}
